import { render } from "./ScrollPane.vue?vue&type=template&id=511a95c4&scoped=true&ts=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=511a95c4&lang=scss&scoped=true"
import "./ScrollPane.vue?vue&type=style&index=1&id=511a95c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511a95c4"]])

export default __exports__